export const loginRoute = '/login';
export const logoutRoute = '/logout';
export const requestNewPasswordRoute = '/passwort-vergessen';
export const courseRoute = '/kursbereich';
export const recordingCourseRoute = '/kursbereich/aufzeichnung';
export const signupRoute = '/kursanmeldung';
export const noPasswordRoute = '/passwort-erstellen';
export const upgradedFromParticipantRoute = '/konto-upgrade';
export const participantSelectionRoute = '/teilnehmer';
export const activationPendingRoute = '/aktivierung';
export const automaticFollowUpBookingRoute = '/automatische-folgekursbuchung';
export const documentsRoute = '/dokumente';
export const startRoute = courseRoute;
